module.exports = __webpack_public_path__ + "static/img/ko.2d625afa.png";